export function getDomainFromUrl(domain: string): string {
  const lower = domain.toLowerCase().trim();
  try {
    const url = lower.startsWith("http") ? new URL(lower) : new URL(`https://${lower}`);
    let host = url.hostname;
    if (host.startsWith("www.")) host = host.slice(4);
    return host;
  } catch {
    return lower;
  }
}